/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Text,
  View,
} from 'react-native';
import Autolink from 'react-native-autolink';

import Header from '../../components/misc/Header';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class Careers extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Careers';
  }

  render() {
    const { history } = this.props;

    const t = translate('company_careers');
    const paragraphs = t.split('\n\n');

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_careers')}
          hasCancel
          history={history}
        />

        {paragraphs.map((paragraph) => (
          <Text style={styles.common.paragraph}>
            <Autolink text={paragraph} />
          </Text>
        ))}
      </View>
    );
  }
}

Careers.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default Careers;
